import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap-5';

export default function ExternalLogin({ externalLoginUrl }) {
  return (
    <div className="text-center">
      <p>Sign in or Sign up with the Newmark Investor Marketplace to access this document</p>
      <Button href={externalLoginUrl}>Access with NIM</Button>
    </div>
  );
}

ExternalLogin.propTypes = {
  externalLoginUrl: PropTypes.string.isRequired
};
